import { Component } from '@angular/core';
import { Links } from '../../../constants';
import { environment } from '../../../../environments/environment';

@Component( {
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
} )
export class FooterComponent {
  link = Links;
  protected readonly environment = environment;
}
